export const CustomCanvasObjectProperties = [
  "clientIdentifier",
  "isPlaceholder",
  "mapping",
  "canvas",
  "assetId",
];

export const FabricTypes = { textBox: "i-text", image: "image" };
